import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/canvas/renderer.module.css";

export default {
  "canvas": "renderer-module__canvas_V2ncHG__010"
};
      